import { ShieldCheck, FlaskConical, Stethoscope } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Compounded at 503A FDA-regulated pharmacies in TX & FL" },
  { icon: Stethoscope, label: "Dispensed by US-licensed pharmacists" },
  { icon: FlaskConical, label: "Sterility & potency tested every batch" },
];

export const SourcingBand = () => {
  return (
    <section aria-label="Sourcing and compliance" className="border-y border-border bg-background py-6 md:py-7">
      <div className="container-wide">
        <ul className="flex flex-col md:flex-row items-start md:items-center justify-center gap-4 md:gap-10 text-[12.5px] text-foreground/70">
          {ITEMS.map((it) => (
            <li key={it.label} className="flex items-center gap-2.5 leading-snug">
              <it.icon className="size-4 text-accent shrink-0" strokeWidth={1.75} aria-hidden />
              {it.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
